module.exports = __webpack_public_path__ + "static/img/DeluxeQueenStudio3.3b76e0c8.jpg";